import React, { useState, useEffect, useRef } from "react";

function SCOTRadio(props) {
  const {
    label,
    name,
    id,
    fieldId,
    isRequired,
    errId,
    divClass,
    options,
    handleRadioChange,
    checkDetailsIndex,
    fieldValue,
    fieldName,
    hasError,
  } = props;

  const handleOnChange = (e) => {
    handleRadioChange(e.target);
  };
  return (
    <>
      <div className="col-sm-4 col-md-12 col-xl-4">
        <div className="form-group">
          <label className="d-block w-100">
            {label}
            {isRequired == 1 && <sup className="text-danger">*</sup>}
          </label>
          {Object.keys(options).map((key, value) => {
            return (
              <div className="form-check form-check-inline">
                <input
                  type="radio"
                  className="form-check-input"
                  name={`${name}-${key}`}
                  id={value}
                  value={options[key]}
                  onChange={(e) => handleOnChange(e)}
                  data-checkdetailsindex={checkDetailsIndex}
                  data-fieldname={fieldName}
                  checked={fieldValue === options[key]}
                />
                <label htmlFor={`${name}-${key}`} className="form-check-label">
                  {key}
                </label>
              </div>
            );
          })}
          {hasError === true && (
            <p className="err text-danger" id={errId}>
              This field is required.
            </p>
          )}
        </div>
      </div>
    </>
  );
}

export default SCOTRadio;
